import React from 'react';
import AboutJSX from './About.jsx';

function About() {
  return <AboutJSX/>;
}

export default About;